<template>
  <v-container class="mt-4">
    <v-row>
      <v-col>You can have a message dispalyed on your customer's portal</v-col>
    </v-row>
    <v-row align="center" class="mt-4">
      <v-col cols="12" sm="10">
        <v-textarea label="Message" v-model="message.message" outlined dense rows="2" :rules="[fieldRules.maxLength(500)]" counter="500" @change="save()"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="2">
        <v-select label="Frequency" v-model="message.frequency" :items="['Once','Hourly','Daily']" outlined dense @change="save()"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AppsPortalMessage',
  data() {
    return {
      message: {}
    }
  },
  async created() {
    const results = await this.$apiCall(`query AppsPortalMessage {
                                           portalMessage {
                                             message,frequency
                                           }
                                         }`,
                                        {}, false, 'portal');
    if (!results.error)
      this.message = results.data.portalMessage;
  },
  methods: {
    async save() {
      await this.$apiCall(`mutation AppsPortalMessage($input:PortalMessageInput!) {
                              portalMessageSet(input:$input) {
                                message,frequency
                              }
                          }`,
                          {input:this.message}, false, 'portal');
    }
  }
}
</script>